import { apiClient } from '@/lib/api/client'
export type ClassificationOption = { id: number; name: string; parent_id: number | null; unavailable?: boolean }
export type ClassificationOptions = { matches: ClassificationOption[]; suggestions: ClassificationOption[]; selected: ClassificationOption | null; canCreate: boolean; parentPath?: string }
export const issueClassificationService = {
  async options(level: number, parentId?: number, query = '', selectedId?: number) {
    const { data } = await apiClient.get<ClassificationOptions>('/options/issue-classification', { params: { level, parent_id: parentId, q: query, selected_id: selectedId } })
    return data
  },
  async add(name: string, level: number, parentId?: number) {
    const { data } = await apiClient.post<ClassificationOption>('/options/issue-classification', { name, level, parent_id: parentId ?? null })
    return data
  },
}
